import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DownloadIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    width: "15",
    height: "16",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 11.9971V14.4971C1 14.7721 1.224 14.9971 1.5 14.9971H13.5C13.776 14.9971 14 14.7721 14 14.4971V11.9971H15V14.4971C15 15.3241 14.327 15.9971 13.5 15.9971H1.5C0.672 15.9971 0 15.3241 0 14.4971V11.9971H1ZM7.9996 0V10.078L11.0356 7.043L11.7426 7.75L7.4996 11.992L3.2576 7.75L3.9646 7.043L6.9996 10.078V0H7.9996Z",
      fill: "currentColor"
    }
  )
);

export { DownloadIcon as default };
//# sourceMappingURL=DownloadIcon.js.map
